import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { UnitPcvItemList } from './models/unitPcv';
import { useParams } from 'react-router-dom';
import useAdminPagination from '../../hooks/useAdminPagination';
import { getUnitPcvPerProjectListEndpoint } from './services/unitPcvService';
import AdminPaginator from '../../components/admin/AdminPaginator';
import AdminPage from '../../components/admin/AdminPage';
import { Col, Row } from 'reactstrap';
import UnitPcvListCard from './components/UnitPcvListCard';
import UnitPcvCreateModal from './components/UnitPcvCreateModal';

const UnitPcvProjectList = () => {
  const { projectId } = useParams();
  const [errorAlert, setErrorAlert] = useState<string | null>(null);

  const pageName = 'PCV';
  const pageParentName = 'Proyectos';
  const globalAlertOptions = {
    success: false,
    warning: true,
    onConfirm: () => setErrorAlert(null),
    title: 'Error',
    text: errorAlert || '',
  };

  const [pcvs, setPcvs] = useState<UnitPcvItemList[]>([]);

  const { paginator, loadItems } = useAdminPagination(
    (query: string, token: string) =>
      getUnitPcvPerProjectListEndpoint(projectId!, query, token),
    setPcvs,
    setErrorAlert,
  );

  const componentPagination = (
    <AdminPaginator
      page={paginator.page}
      totalPages={paginator.pageCount}
      onPageChange={loadItems}
    />
  );

  return (
    <AdminPage
      name={pageName}
      parentName={pageParentName}
      globalAlertOptions={globalAlertOptions}
      footer={componentPagination}
      header={<UnitPcvCreateModal projectId={projectId!} />}
    >
      <div>
        <Row>
          {pcvs && pcvs.length > 0 ? (
            pcvs.map((pcv) => (
              <Col key={pcv.id} lg={3} md={4} className="mb-4">
                <UnitPcvListCard pcv={pcv} />
              </Col>
            ))
          ) : (
            <Col>
              <p className="text-center text-muted">No se encontraron pcvs</p>
            </Col>
          )}
        </Row>
      </div>
    </AdminPage>
  );
};

export default UnitPcvProjectList;
